"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _rcCheckbox = _interopRequireDefault(require("rc-checkbox"));

var _ramda = require("ramda");

var _withFieldWrapper = _interopRequireDefault(require("../hocs/withFieldWrapper"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var RadioComponent = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(RadioComponent, _Component);

  var _super = _createSuper(RadioComponent);

  function RadioComponent() {
    var _this;

    (0, _classCallCheck2["default"])(this, RadioComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (_ref) {
      var target = _ref.target;
      var onChange = _this.props.input.onChange;
      onChange(target.value);
    });
    return _this;
  }

  (0, _createClass2["default"])(RadioComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          settings = _this$props.settings,
          getDictionary = _this$props.getDictionary;
      var dictionary = (0, _ramda.path)(['dictionary'], settings);

      if (dictionary) {
        getDictionary(dictionary);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          _this$props2$input = _this$props2.input,
          _this$props2$input$va = _this$props2$input.value,
          value = _this$props2$input$va === void 0 ? [] : _this$props2$input$va,
          name = _this$props2$input.name,
          options = _this$props2.options,
          disabled = _this$props2.disabled;
      return options && !(0, _ramda.isEmpty)(options) ? /*#__PURE__*/_react["default"].createElement("div", {
        id: "".concat(name, "-radio"),
        className: "radio-block"
      }, options.map(function (_ref2) {
        var checkboxValue = _ref2.value,
            label = _ref2.label;
        return /*#__PURE__*/_react["default"].createElement("label", {
          className: "radio-wrapper",
          key: label
        }, /*#__PURE__*/_react["default"].createElement(_rcCheckbox["default"], {
          id: name,
          onChange: _this2.onChange,
          className: "radio",
          checked: checkboxValue === value,
          value: checkboxValue,
          disabled: disabled
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: "radio-label"
        }, label));
      })) : null;
    }
  }]);
  return RadioComponent;
}(_react.Component);

(0, _defineProperty2["default"])(RadioComponent, "propTypes", {
  value: _propTypes["default"].array,
  disabled: _propTypes["default"].bool,
  options: _propTypes["default"].array
});
(0, _defineProperty2["default"])(RadioComponent, "defaultProps", {
  value: []
});
var Radio = (0, _withFieldWrapper["default"])(RadioComponent);
var _default = Radio;
exports["default"] = _default;